export default __webpack_public_path__ + "static/media/cloudinaryLogo@2x.b2daff02.png";